export default "__VITE_ASSET__q5c9t7rV__"